import { render, staticRenderFns } from "./NewItem.vue?vue&type=template&id=2c90c722&"
import script from "./NewItem.vue?vue&type=script&lang=js&"
export * from "./NewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports